import { SearchInput } from 'components/search-input';
import React from 'react';
import I18n from 'i18n-js';
import styles from './comunities-solicitudes-pendiente-list-page-new-onboarding-filters.module.scss';

interface FilterText {
  handleChange(value: any): void;
  acabadas?: boolean;
}

export const SolicitudPendienteListPageFilter = (props: FilterText): JSX.Element => {
  const { t } = I18n;
  const { handleChange, acabadas } = props;

  return (
    <div className={styles.container}>
      <div className={styles.left_wrapper}>
        <p className={styles.title}>
          {acabadas ? t(`PendingRequestsTable.titleAcabadas`) : t(`PendingRequestsTable.title`)}
        </p>
        <SearchInput
          placeholder={t(`ComunitiesEnrolledListPage.searchPlaceholder`)}
          onChange={(event) => {
            handleChange(event.target.value);
          }}
        />
      </div>
    </div>
  );
};
